/* eslint-disable no-undef */
export default {
	init() {
		// JavaScript to be fired on the home page

		// Masthead carousel
		if ($('.masthead-carousel').length > 0) {
			var $slider = $('.masthead-carousel');

			$(document).ready(function () {
				setTimeout(() => {
					$slider.slick({
						slide: '.masthead-carousel .masthead-carousel__slide',
						autoplay: true,
						autoplaySpeed: 6000,
						infinite: true,
						cssEase: 'ease',
						slidesToShow: 1,
						slidesToScroll: 1,
						swipeToSlide: true,
						pauseOnFocus: false,
						pauseOnHover: false,
						fade: true,
						dots: true,
						arrows: true,
						speed: 50,
						rows: 0,
						nextArrow:
							'<button type="button" class="slick-next"><span class="screen-reader-text">Next</span><i class="icon-arrow-right"></i></button>',
						prevArrow:
							'<button type="button" class="slick-prev"><span class="screen-reader-text">Previous</span><i class="icon-arrow-left"></i></button>',
					});

					// Adjust right arrow so it aligns next to dots
					let $slickDots = $('.slick-dots li');
					let $slickRightArrow = $('.slick-next');
					if ($slickDots && $slickRightArrow) {
						let $slickCount = $slickDots.length;
						let $slickDotWidth = $($slickDots[0]).outerWidth(true);
						// console.log(slickDotWidth);
						$slickRightArrow.css(
							'left',
							$slickDotWidth * $slickCount + 37 + 'px'
						);
					}
				}, 1000);

				// eslint-disable-next-line no-unused-vars
				$slider.on('beforeChange', function (event, slick, direction) {
					// find current nav dot
					var $currentDot = $('.slick-dots .slick-active');
					$currentDot.addClass('prev-dot');
				});

				// remove classes once slide resets
				// eslint-disable-next-line no-unused-vars
				$slider.on(
					'beforeChange',
					function (event, slick, currentSlide) {
						if (slick.$slides.length - 1 == currentSlide) {
							var $dots = $('.slick-dots li');
							$dots.removeClass('prev-dot');
						}
					}
				);
			});
		}

        /**
         * initMap
         *
         * Renders a Google Map onto the selected jQuery element
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   jQuery $el The jQuery element.
         * @return  object The map instance.
         */
		function initMap($el) {
			// Find marker elements within map.
			var $markers = $el.find('.marker');

			// Create generic map.
			var mapArgs = {
				zoom: $el.data('zoom') || 12,
				// eslint-disable-next-line no-undef
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				disableDefaultUI: true,
				styles: [
					{
						elementType: 'geometry',
						stylers: [{ color: '#192742' }],
					},
					{
						elementType: 'labels.text.fill',
						stylers: [{ color: '#fe821f' }],
					},
					{
						elementType: 'labels.text.stroke',
						stylers: [{ color: '#2c4450' }],
					},
					{
						featureType: 'administrative',
						elementType: 'geometry',
						stylers: [{ visibility: 'off' }],
					},
					{
						featureType: 'administrative.country',
						elementType: 'geometry.stroke',
						stylers: [{ color: '#346a76' }],
					},
					{
						featureType: 'administrative.land_parcel',
						stylers: [{ visibility: 'off' }],
					},
					{
						featureType: 'administrative.land_parcel',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#64779e' }],
					},
					{
						featureType: 'administrative.neighborhood',
						stylers: [{ visibility: 'off' }],
					},
					{
						featureType: 'administrative.province',
						elementType: 'geometry.stroke',
						stylers: [{ color: '#346b78' }],
					},
					{
						featureType: 'landscape.man_made',
						elementType: 'geometry.stroke',
						stylers: [{ color: '#334e87' }],
					},
					{
						featureType: 'landscape.natural',
						elementType: 'geometry',
						stylers: [{ color: '#1a4a5e' }],
					},
					{ featureType: 'poi', stylers: [{ visibility: 'off' }] },
					{
						featureType: 'poi',
						elementType: 'geometry',
						stylers: [{ color: '#283d6a' }],
					},
					{
						featureType: 'poi',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#6f9ba5' }],
					},
					{
						featureType: 'poi',
						elementType: 'labels.text.stroke',
						stylers: [{ color: '#1d2c4d' }],
					},
					{
						featureType: 'poi.park',
						elementType: 'geometry.fill',
						stylers: [{ color: '#023e58' }],
					},
					{
						featureType: 'poi.park',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#3C7680' }],
					},
					{
						featureType: 'road',
						elementType: 'geometry',
						stylers: [{ color: '#3c547d' }, { weight: 0.5 }],
					},
					{
						featureType: 'road',
						elementType: 'labels',
						stylers: [{ visibility: 'off' }],
					},
					{
						featureType: 'road',
						elementType: 'labels.icon',
						stylers: [{ visibility: 'off' }],
					},
					{
						featureType: 'road',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#98a5be' }],
					},
					{
						featureType: 'road',
						elementType: 'labels.text.stroke',
						stylers: [{ color: '#1d2c4d' }],
					},
					{
						featureType: 'road.highway',
						elementType: 'geometry',
						stylers: [{ color: '#2c6675' }, { weight: 2 }],
					},
					{
						featureType: 'road.highway',
						elementType: 'geometry.stroke',
						stylers: [{ weight: 1.5 }],
					},
					{
						featureType: 'road.highway',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#b0d5ce' }],
					},
					{
						featureType: 'road.highway',
						elementType: 'labels.text.stroke',
						stylers: [{ color: '#023e58' }],
					},
					{
						featureType: 'transit',
						stylers: [{ visibility: 'off' }],
					},
					{
						featureType: 'transit',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#98a5be' }],
					},
					{
						featureType: 'transit',
						elementType: 'labels.text.stroke',
						stylers: [{ color: '#1d2c4d' }],
					},
					{
						featureType: 'transit.line',
						elementType: 'geometry.fill',
						stylers: [{ color: '#283d6a' }],
					},
					{
						featureType: 'transit.station',
						elementType: 'geometry',
						stylers: [{ color: '#3a4762' }],
					},
					{
						featureType: 'water',
						elementType: 'geometry',
						stylers: [{ color: '#1b2835' }],
					},
					{
						featureType: 'water',
						elementType: 'labels.text',
						stylers: [{ visibility: 'off' }],
					},
					{
						featureType: 'water',
						elementType: 'labels.text.fill',
						stylers: [{ color: '#4e6d70' }],
					},
				],
			};
			var map = new google.maps.Map($el[0], mapArgs);

			// Add markers.
			map.markers = [];
			$markers.each(function () {
				initMarker($(this), map);
			});

			// Center map based on markers.
			centerMap(map);

			// Return map instance.
			return map;
		}

        /**
         * initMarker
         *
         * Creates a marker for the given jQuery element and map.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   jQuery $el The jQuery element.
         * @param   object The map instance.
         * @return  object The marker instance.
         */
		function initMarker($marker, map) {
			// Get position from marker.
			var lat = $marker.data('lat');
			var lng = $marker.data('lng');
			var latLng = {
				lat: parseFloat(lat),
				lng: parseFloat(lng),
			};
			var icon =
				'https://www.11thhourracingteam.org/wp-content/uploads/marker.png';

			// Set icon graphic

			// Create marker instance.
			var marker = new google.maps.Marker({
				position: latLng,
				map: map,
				icon: icon,
			});

			// Append to reference for later use.
			map.markers.push(marker);

			// If marker contains HTML, add it to an infoWindow.
			if ($marker.html()) {
				// Create info window.
				var infowindow = new google.maps.InfoWindow({
					content: $marker.html(),
				});

				// Show info window when marker is clicked.
				google.maps.event.addListener(marker, 'click', function () {
					infowindow.open(map, marker);
				});
			}
		}

        /**
         * centerMap
         *
         * Centers the map showing all markers in view.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   object The map instance.
         * @return  void
         */
		function centerMap(map) {
			// Create map boundaries from all map markers.
			var bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function (marker) {
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng(),
				});
			});

			// Case: Single marker.
			if (map.markers.length == 1) {
				map.setCenter(bounds.getCenter());

				// Case: Multiple markers.
			} else {
				map.fitBounds(bounds);
			}
		}

		// Render maps on page load.
		$(document).ready(function () {
			$('.acf-map').each(function () {
				// eslint-disable-next-line no-unused-vars
				var map = initMap($(this));
			});
		});

		// lofi accordion
		let accordion = $('.scrolling-content__accordion'),
			content = $('.scrolling-content__accordion-content'),
			title = $('.scrolling-content__accordion-title');

		title.click(function () {
			accordion.toggleClass('scrolling-content__accordion--active');
			content.slideToggle();
		});
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js